import React, { createContext, useCallback, useContext, useMemo, useRef, useState } from "react";

const PerguntarIaLayoutContext = createContext(null);

/** Registra o edital da página Resultados para o botão "Pergunte a IA" no header global. */
export function PerguntarIaLayoutProvider({ children }) {
  const [edital, setEdital] = useState(null);
  const onUpdateRef = useRef(null);

  const register = useCallback((nextEdital, onUpdate) => {
    setEdital(nextEdital ?? null);
    onUpdateRef.current = typeof onUpdate === "function" ? onUpdate : null;
  }, []);

  const clear = useCallback(() => {
    setEdital(null);
    onUpdateRef.current = null;
  }, []);

  const invokeOnUpdate = useCallback((updated) => {
    onUpdateRef.current?.(updated);
  }, []);

  const value = useMemo(
    () => ({ edital, register, clear, invokeOnUpdate }),
    [edital, register, clear, invokeOnUpdate]
  );

  return (
    <PerguntarIaLayoutContext.Provider value={value}>{children}</PerguntarIaLayoutContext.Provider>
  );
}

export function usePerguntarIaLayout() {
  const ctx = useContext(PerguntarIaLayoutContext);
  if (!ctx) {
    throw new Error("usePerguntarIaLayout deve ser usado dentro de PerguntarIaLayoutProvider");
  }
  return ctx;
}
